import {styled} from "@reside/ui";

/** Groups admin / announcements / help / profile; spaced and vertically centered in the nav bar. */
export const HeaderRightActions = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  gap: 16px;
  margin-left: auto;
  flex-shrink: 0;
`;

/** User profile menu trigger in the header. */
export const MediaWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FacilityFilterWrapper = styled.div`
  margin-left: 36px;
  margin-right: 0;

  @media (max-width: 768px) {
    margin-left: 28px;
    margin-right: -8px;
  }

  display: flex;
  align-items: center;
  i {
    margin-right: 2px;
  }
`;
